import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "onedesk-dropdown onedesk-input" };
import { computed, ref, watch } from "vue";
import AutoComplete from "primevue/autocomplete";
import Skeleton from "primevue/skeleton";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskAutocompleteDrowpdown',
    props: {
        lineraLabel: { type: Boolean, default: true },
        options: { default: () => [] },
        modelValue: { default: "" },
        optionLabel: { default: "label" },
        optionValue: { default: "value" },
        forceSelection: { type: Boolean, default: true },
        fullWidth: { type: Boolean, default: true },
        inputClass: { default: "" },
        placeholder: { default: "" },
        loading: { type: Boolean, default: false },
        filter: { type: [Function, null], default: null },
        multiple: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const labelClassName = computed(() => "onedesk-dropdown-label " + (props.lineraLabel ? "onedesk-dropdown-label-linear" : ""));
        const selected = ref();
        const filteredResults = ref();
        watch(selected, (currentValue) => emit("update:modelValue", currentValue));
        watch(() => props.options, (currentValue) => selected.value = currentValue.find((element) => element[props.optionValue] == props.modelValue), { deep: true });
        watch(() => props.modelValue, (value) => selected.value = value);
        const defaultFilter = (value) => {
            return props.options.filter((element) => element[props.optionLabel].includes(value));
        };
        const search = (query) => {
            filteredResults.value = (props.filter ?? defaultFilter)(query);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(labelClassName.value)
                }, [
                    _renderSlot(_ctx.$slots, "label")
                ], 2),
                _createElementVNode("span", {
                    class: _normalizeClass(_ctx.fullWidth ? 'p-fluid' : '')
                }, [
                    (!_ctx.loading)
                        ? (_openBlock(), _createBlock(_unref(AutoComplete), {
                            key: 0,
                            modelValue: selected.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selected).value = $event)),
                            multiple: false,
                            suggestions: filteredResults.value,
                            field: _ctx.optionLabel,
                            "force-selection": _ctx.forceSelection,
                            "input-class": _ctx.inputClass + ' one-desk-input',
                            placeholder: _ctx.placeholder,
                            onComplete: _cache[1] || (_cache[1] = ($event) => (search($event.query)))
                        }, null, 8, ["modelValue", "suggestions", "field", "force-selection", "input-class", "placeholder"]))
                        : (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 1,
                            height: "50px",
                            "border-radius": "8px"
                        }))
                ], 2)
            ]));
        };
    }
});
